export default __webpack_public_path__ + "static/media/labgrown.2929006d.svg";